import { useIsMobile } from './useIsMobile';

function useIsDesktop() {
    return !useIsMobile();
}

export { useIsDesktop };
